import React from 'react';
import {
  Users,
  CheckSquare,
  User,
  LogOut,
  ChevronLeft,
  HelpCircle,
  Bug,
  Plug
} from 'lucide-react';
import './Sidebar.css';

interface SidebarProps {
  onNavigate: (path: string) => void;
  currentPath: string;
  user?: any;
  onLogout?: () => void;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onProfileClick?: () => void;
  onChatClick?: () => void;
  onWalkthroughClick?: () => void;
  onChromeExtensionWalkthroughClick?: () => void;
  onReportBug?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  onNavigate, 
  currentPath, 
  user, 
  onLogout, 
  isCollapsed = false, 
  onToggleCollapse, 
  onProfileClick,
  onChatClick,
  onWalkthroughClick,
  onChromeExtensionWalkthroughClick,
  onReportBug
}) => {

  const getFirstName = (name: string) => {
    return name.split(' ')[0];
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Collapse Button */}
      <div className="sidebar-header">
        <button 
          className="collapse-button"
          onClick={onToggleCollapse}
          title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
        >
          <ChevronLeft size={16} />
        </button>
        {!isCollapsed && (
          <span className="sidebar-brand">
            Hey {user?.name ? getFirstName(user.name) : (user?.email || 'there')}! 🐭
          </span>
        )}
      </div>

      {/* Navigation Items */}
      <div className="sidebar-nav">
        <div
          className={`nav-item ${currentPath === '/app/people' || currentPath.startsWith('/app/people/') ? 'active' : ''}`}
          onClick={() => onNavigate('/app/people')}
        >
          <Users className="nav-icon" size={16} />
          {!isCollapsed && <span className="nav-text">People</span>}
        </div>

        <div
          className={`nav-item ${currentPath === '/app/tasks' ? 'active' : ''}`}
          onClick={() => onNavigate('/app/tasks')}
        >
          <CheckSquare className="nav-icon" size={16} />
          {!isCollapsed && <span className="nav-text">Tasks</span>}
        </div>

        <div
          className={`nav-item ${currentPath === '/app/integrations' ? 'active' : ''}`}
          onClick={() => onNavigate('/app/integrations')}
        >
          <Plug className="nav-icon" size={16} />
          {!isCollapsed && <span className="nav-text">Integrations</span>}
        </div>

      </div>

      {/* Help and Report Bug (only visible when expanded, above user menu) */}
      <div className="sidebar-help-section">
        <button 
          className="sidebar-help-button" 
          title="Help & Walkthroughs"
          onClick={() => onWalkthroughClick?.()}
        >
          <HelpCircle className="nav-icon" size={16} />
          {!isCollapsed && <span className="nav-text">Help</span>}
        </button>

        {/* Report Bug Button */}
        {onReportBug && (
          <div 
            className={`nav-item`}
            onClick={onReportBug}
          >
            <Bug className="nav-icon" size={16} />
            {!isCollapsed && <span className="nav-text">Report Bug</span>}
          </div>
        )}
      </div>

      {/* User Menu (at bottom) */}
      {user && (
        <div className="sidebar-user-menu">
          <div 
            className="user-info clickable"
            onClick={onProfileClick}
            style={{ cursor: onProfileClick ? 'pointer' : 'default' }}
          >
            {!isCollapsed && <User size={16} />}
            {!isCollapsed && <span className="user-name">{user.name || user.email}</span>}
          </div>
          {onLogout && (
            <button 
              className="logout-btn"
              onClick={onLogout}
              title="Logout"
            >
              <LogOut size={16} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
